export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";